// ******************************************* Import packages *******************************************
import React, { useRef } from "react";
import "./input.css";
import { GoEyeClosed, GoEye } from "react-icons/go";

const Index = (props) => {
  const {
    className,
    placeholder,
    width,
    disabled,
    value,
    onChange,
    onKeyDown,
    type,
    name,
    error,
    onBlur,
    min,
    position,
    max,
    styles,
    onKeyPress,
    autoComplete,
    isToggled,
    onFocus,
    cNeed,
    setShowPassword,
    showPassword,
    password,
    setPassword,
    feildType
  } = props;

  const inputRef = useRef(null);

  return (
    // <div className="w-100 d-flex align-items-center position-relative input-wrapper">
    //   <input
    //     ref={inputRef}
    //     style={{
    //       border: error
    //         ? "1px solid red"
    //         : isToggled
    //           ? "1px solid #333"
    //           : "1px solid #E2E3E5",
    //       cursor: disabled ? "not-allowed" : "auto",
    //       position: position ? position : null,
    //       textTransform: cNeed ? "capitalize" : "none",
    //       ...styles,
    //     }}
    //     className={` placeholderss ${className ? className : "custom-input mb-2"
    //       } ${isToggled ? "custom-input-dark" : ""} `}
    //     value={value}
    //     min={min}
    //     maxLength={max}
    //     autoComplete={autoComplete}
    //     placeholder={placeholder}
    //     width={width}
    //     disabled={disabled}
    //     onChange={onChange ? (e) => onChange(e) : null}
    //     onBlur={onBlur}
    //     onFocus={onFocus}
    //     onKeyDown={onKeyDown}
    //     type={type}
    //     name={name}
    //     onKeyPress={(e) => {
    //       if (onKeyPress) onKeyPress(e);
    //       if (e.key === " " && inputRef.current.value.length === 0)
    //         e.preventDefault();
    //     }}
    //     onClick={(e) => {
    //       if (type === "date" && inputRef.current?.showPicker) {
    //         inputRef.current.showPicker();
    //       }
    //       if (type === "time" && inputRef.current?.showPicker) {
    //         inputRef.current.showPicker();
    //       }
    //     }}
    //   />
    //   {feildType === "userpassword" && (
    //     <div
    //       onClick={() => setShowPassword(!showPassword)}
    //       className="cursor-pointer absolute right-0"
    //     >
    //       {showPassword ? <GoEye /> : <GoEyeClosed />}
    //     </div>
    //   )}

    // </div>
    <div className="w-100 d-flex align-items-center position-relative input-wrapper">
      <input
        ref={inputRef}
        style={{
          border: error
            ? "1px solid red"
            : isToggled
              ? "1px solid #333"
              : "1px solid #E2E3E5",
          cursor: disabled ? "not-allowed" : "auto",
          textTransform: cNeed ? "capitalize" : "none",
          paddingRight: feildType === "userpassword" ? "2.5rem" : undefined, // ✅ add padding so text doesn't overlap icon
          ...styles,
        }}
        className={`placeholderss ${className ? className : "custom-input mb-2"
          } ${isToggled ? "custom-input-dark" : ""}`}
        value={value}
        min={min}
        maxLength={max}
        autoComplete={autoComplete}
        placeholder={placeholder}
        width={width}
        disabled={disabled}
        onChange={onChange ? (e) => onChange(e) : null}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        type={type}
        name={name}
        onKeyPress={(e) => {
          if (onKeyPress) onKeyPress(e);
          if (e.key === " " && inputRef.current.value.length === 0) e.preventDefault();
        }}
        onClick={(e) => {
          if (type === "date" && inputRef.current?.showPicker) {
            inputRef.current.showPicker();
          }
          if (type === "time" && inputRef.current?.showPicker) {
            inputRef.current.showPicker();
          }
        }}
      />

      {feildType === "userpassword" && (
        <div
          onClick={() => setShowPassword(!showPassword)}
          className="cursor-pointer"
          style={{
            position: "absolute",
            right: "10px",   // ✅ adjust horizontal position
            top: "50%",
            transform: "translateY(-50%)", // ✅ vertically center
            color: isToggled ? "#fff" : "#606162",
          }}
        >
          {showPassword ? <GoEye /> : <GoEyeClosed />}
        </div>
      )}
    </div>

  );
};

export default Index;
